import { Header, Space } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type IConversationVendorOrderSummaryGroup } from './ConversationVendorOrderSummary'
import messages from './messages'
import {
  type CatalogItemTagIcon,
  CatalogItemTagIcons,
} from '../../value-objects/CatalogItemTag'
import { CatalogItemTag } from '../CatalogItemTag'
import { VendorLogoBadge } from '../VendorLogoBadge'

const SOURCE_ICONS: Record<string, CatalogItemTagIcon> = {
  catalog: CatalogItemTagIcons.CATALOG,
  history: CatalogItemTagIcons.PREVIOUS_ORDER,
}

export interface IConversationVendorOrderSummaryHeadingProps {
  group: IConversationVendorOrderSummaryGroup
}

export const ConversationVendorOrderSummaryHeading = ({
  group,
}: IConversationVendorOrderSummaryHeadingProps) => {
  const intl = useProcurifyIntl()
  const count = group.items.length
  const { vendor } = group

  const renderSource = () => {
    if (!vendor) return null
    if (vendor.logoUrl) return <VendorLogoBadge vendor={vendor} />
    return <CatalogItemTag icon={SOURCE_ICONS[vendor.id]} text={vendor.name} />
  }

  return (
    <Space direction='horizontal' size='small' align='center'>
      <Header as='h5'>
        {vendor
          ? intl.formatMessage(messages.groupHeading, { count })
          : intl.formatMessage(messages.heading, { count })}
      </Header>
      {renderSource()}
    </Space>
  )
}
